import React from 'react'
import { Footer, Navbar } from "../components";
const AboutPage = () => {
  return (
    <>
      <Navbar />
      <div className="container my-3 py-3">
        <h1 className="text-center">About Us</h1>
        <hr />
        <p className="lead text-center">
        At PremiumGadgetsCovers, we believe that your devices deserve more than just protection—they deserve style, durability, and a touch of luxury. We specialize in high-quality covers and accessories for today’s most loved gadgets, including smartphones, laptops, Apple Watches, and more.

Whether it’s a sleek mobile case, a stylish Apple Watch strap, a rugged laptop cover, or a crystal-clear screen guard, every product we offer is carefully curated to combine premium quality with modern aesthetics. Our goal is simple: to enhance your tech experience while keeping your devices safe and looking their best.

We cater to customers who value both functionality and design, offering gear that matches your lifestyle, complements your personality, and elevates your everyday essentials.

Why choose us?
✔️ Premium Materials
✔️ Precision Fit
✔️ Elegant & Minimalist Designs
✔️ Affordable Luxury
✔️ Fast Shipping & Responsive Support

Join the PremiumGadgetsCovers family and protect your devices in style. Your tech, your vibe — covered.
        </p>
        <h2 className="text-center py-4">Our Products</h2>
        <div className="row">
          <div className="col-md-3 col-sm-6 mb-3 px-3">
            <div className="card h-100">
              <img className="card-img-top img-fluid" src="./assets/icLuxuryPhoneCovers.jpg" alt="" height={160} />
              <div className="card-body">
                <h5 className="card-title text-center">Exquisite Luxury Phone Covers</h5>
              </div>
            </div>
          </div>
          <div className="col-md-3 col-sm-6 mb-3 px-3">
            <div className="card h-100">
              <img className="card-img-top img-fluid" src="./assets/icAppleWatchStrap.png" alt="" height={160} />
              <div className="card-body">
                <h5 className="card-title text-center">Apple Watch Straps</h5>
              </div>
            </div>
          </div>
          <div className="col-md-3 col-sm-6 mb-3 px-3">
            <div className="card h-100">
              <img className="card-img-top img-fluid" src="./assets/icScreenProtector.jpg" alt="" height={160} />
              <div className="card-body">
                <h5 className="card-title text-center">Premium Screen Guards for Mobile Phones, Apple Watch, and MacBook</h5>
              </div>
            </div>
          </div>
          <div className="col-md-3 col-sm-6 mb-3 px-3">
            <div className="card h-100">
              <img className="card-img-top img-fluid" src="./assets/icProtectiveCaseMacBook.avif" alt="" height={160} />
              <div className="card-body">
                <h5 className="card-title text-center">Stylish Laptop Covers</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}

export default AboutPage